import React from 'react'

const SvgYoutube = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='14'
    height='14'
    viewBox='0 0 14 14'
  >
    <defs>
      <clipPath id='master_svg0_126_6137'>
        <rect x='0' y='0' width='14' height='14' rx='0' />
      </clipPath>
    </defs>
    <g clipPath='url(#master_svg0_126_6137)'>
      <g>
        <g>
          <path
            d='M0.592048,10.9424475C0.205976,10.2590275,0,9.0765175,0,7.0035575L0,6.9972275C0,4.9242675,0.205976,3.7406975,0.592048,3.0567525C0.97812,2.3738645,1.39166,2.2465825,2.22823,2.1948247C3.06587,2.1414819,5.17104,2.1171875,6.99947,2.1171875C8.82843,2.1171875,10.9325,2.1414819,11.7718,2.1948247C12.6094,2.2465825,13.0214,2.3738645,13.4064,3.0567525C13.793,3.7406975,14,4.9263775,14,6.9998675C14,9.072297500000001,13.793,10.2590275,13.4064,10.9424475C13.0214,11.6269175,12.6073,11.7520875,11.7718,11.8054375C10.9325,11.8571875,8.82843,11.8825375,6.99947,11.8825375C5.17104,11.8825375,3.06587,11.8571875,2.22823,11.8054375C1.38849,11.7520875,0.97812,11.6269175,0.592048,10.9424475ZM9.46875,6.6835975L5.5,9.2539075L5.5,4.1171875L9.46875,6.6835975Z'
            fillRule='evenodd'
            fill='#333333'
            fillOpacity='1'
          />
        </g>
      </g>
    </g>
  </svg>
)

export default SvgYoutube
